import { Component } from '@angular/core';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { CultureInfo } from '@app/core/types/config/config.types';

@Component({
    selector: 'c-language-picker-modal',
    templateUrl: './language-picker-modal.component.html',
    styleUrls: ['./language-picker-modal.component.scss'],
    standalone: false
})
export class LanguagePickerModalComponent {
  readonly closeIcon = faXmark;
  languages: CultureInfo[];
  close!: (language?: CultureInfo) => void;
}
